import React, { useCallback } from 'react';
import styled from '@emotion/styled';
import { useSetAtom } from 'jotai';
import SubscriptionGuideModal, { SUBSCRIPTION_GUIDE_LAND_FROM } from 'src/components/AzarOnly/Subscription/SubscriptionGuideModal';
import { showModalAtom } from 'src/stores/modal/atoms';
import type { ItemDetail } from 'src/types/itemInventory';
import { ModalType } from 'src/types/Modal';
import Category from './Category';
import ItemCard from './ItemCard';
interface Props {
  items: ItemDetail[];
}
const SubscriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
const Subscription: React.FC<Props> = ({
  items
}) => {
  const showModal = useSetAtom(showModalAtom);
  const handleItemClick = useCallback((item: ItemDetail) => {
    showModal({
      key: ModalType.SUBSCRIPTION_GUIDE,
      component: () => <SubscriptionGuideModal defaultPageId={item.categoryId} landFrom={SUBSCRIPTION_GUIDE_LAND_FROM.ITEM_INVENTORY} />
    });
  }, [showModal]);
  return <Category title='inventory_subscriptions_title' data-sentry-element="Category" data-sentry-component="Subscription" data-sentry-source-file="Subscription.tsx">
      <SubscriptionWrapper data-sentry-element="SubscriptionWrapper" data-sentry-source-file="Subscription.tsx">
        {items.map(item => <ItemCard item={item} key={`SubscribedItem-${item.itemId}`} onClick={() => handleItemClick(item)} />)}
      </SubscriptionWrapper>
    </Category>;
};
export default Subscription;